module.exports = __webpack_public_path__ + "static/img/20240426.0b8f5f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20240426.jpg
// module id = MCv3
// module chunks = 96